import React from 'react';

const Logo = (props) => {
  return (
      <img src="/logo.png" title="DriveEnergy" alt="DriveEnergy icon" className={props.className} />
  );
};

export default Logo;
